/**
 * Created by xing.lin on 2020/9/3.
 */
import _import from './_import.js';

export default [{
    path: 'mall',
    name: 'mall',
    component: _import('us_mall/layout'),
    alias: [''],
    redirect: {
        name: 'newHome'
    },
    children: [
        // 首页
        {
           path: 'index',
           name:"newHome",
           alias: [''],
           component: _import('us_mall/home/index')
        },
        {
           path: 'product_detail/:device_type',
           name:"productDetail",
           alias: [''],
           component: _import('us_mall/home/product_detail')
        },
        //  下单成功
        {
            path: 'orderSuccess',
            component: _import('us_mall/order/orderSuccess')
        },
        // 购买设备
        {
            path: 'product_choose',
            component: _import('us_mall/mall/product_choose')
        },
        // 购物车
        {
            path: 'cart',
            component: _import('us_mall/mall/cart')
        },
        // 下单
        {
            path: 'orderSettlement',
            component: _import('us_mall/order/order_settlement')
        },
        // 申请退货
        {
            path: 'return_apply',
            component: _import('us_mall/order/return_apply')
        },
        // 退货成功
        {
            path: 'return_suc',
            component: _import('us_mall/order/return_suc')
        },
        // 取消订单
        {
            path: 'order_cancel',
            component: _import('us_mall/order/order_cancel')
        },
        // 订单已取消
        {
            path: 'order_canceled',
            component: _import('us_mall/order/order_canceled')
        },
        // 支付页
        {
            path: 'paymentPage',
            component: _import('us_mall/order/paymentPage')
        },
        // 服务
        {
            path: 'service/index',
            component: _import('us_mall/service/index')
        },
        // 隐私政策
        {
            path: 'service/policy',
            component: _import('us_mall/service/policy')
        },
        // 关于
        {
            path: 'about/us',
            component: _import('us_mall/service/about')
        },
        // cooperation
        {
            path: 'about/cooperation',
            component: _import('us_mall/service/cooperation')
        },
        // 关于
        {
            path: 'about/contact',
            component: _import('us_mall/service/contact_us')
        },
        // how
        {
            path: 'how',
            component: _import('us_mall/how/how_index')
        },
        // 购买记录---设备订单详情
        {
            path: 'member/myDeviceOrderDetail',
            name: 'myDeviceOrderDetail',
            component: _import('member/myDeviceOrderDetail'),
            meta: {
                requiresAuth: true
            },
        },
        // 再次支付
        {
            path: 'repayments',
            component: _import('us_mall/order/repayments')
        },
    ]
}
]



// WEBPACK FOOTER //
// ./src/router/us_mall.js